<template>
  <div class="whole-course">
    <div ref="datePicker"></div>
    <div @keyup.13="$refs.table.refresh(true)" class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="12" :sm="24" style="text-align: end">
            <a-form-item label="查询日期">
              <a-range-picker
                :getCalendarContainer="()=>$refs.datePicker"
                :placeholder="['开始日期','结束日期']"
                format="YYYY-MM-DD"
                v-model="queryParam.courseDate"
              />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="$refs.table.refresh(true)" type="primary">查询</a-button>
              <a-button @click="resetSearch" class="reset-btn">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-card style="margin-top:0.3rem">
      <a-alert style="margin-bottom: 0.1875rem;" :message="wholeName + '课程体系介绍'" :description="wholeRemarks" type="info" closable />
      <s-table
        :columns="columns"
        :data="loadData"
        :scroll="{ x:1280 }"
        class="scroll-table-wrap"
        ref="table"
        rowKey="id"
        size="default">
        <span slot="courseDateRange" slot-scope="text, record">
          <a @click="goToCourseList(record)">{{ record.startDate }}~{{ record.finishDate }}</a>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="goToPay(record)">选定</a>
        </span>
      </s-table>
    </a-card>
  </div>
</template>
<script>
  import STable from '@/components/table/'
  import { mapState } from 'vuex'
  import { getListByCode } from '@/api/dict'
  import whole from '../../api/whole'
  import moment from 'moment'

  export default {
    name: 'TestPaper',
    components: {
      STable
    },
    data() {
      return {
        dictCode: 'payType',
        options: {},
        queryParam: {},
        wholeName: '',
        wholeRemarks: '',
        columns: [
          {
            title: '课程日期',
            dataIndex: 'testPaperName',
            className: 'min-wid-m',
            scopedSlots: { customRender: 'courseDateRange' }
          },
          {
            title: '支付方式',
            dataIndex: 'payType',
            className: 'min-wid-s',
            ellipsis: true,
            customRender: text => {
              const target = this.options.payType.filter(item => (text).split(',').includes(item.value))
              return target.map(item => item.label).join('，')
            }
          },
          {
            title: '学时',
            dataIndex: 'classHour',
            className: 'min-wid-s',
            ellipsis: true
          },
          {
            title: '操作',
            dataIndex: 'action',
            className: 'min-wid-m',
            scopedSlots: { customRender: 'action' }
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          const transferQuery = JSON.parse(JSON.stringify(this.queryParam))
          if (transferQuery.courseDate !== null && transferQuery.courseDate !== undefined && transferQuery.courseDate.length !== 0) {
            transferQuery.startDate = moment(transferQuery.courseDate[0]).format('YYYY-MM-DD')
            transferQuery.finishDate = moment(transferQuery.courseDate[1]).format('YYYY-MM-DD')
            transferQuery.courseDate = null
          }
          transferQuery.wholeId = sessionStorage.getItem('wholeId')
          const order = parameter.sortOrder !== undefined ? parameter.sortOrder.substring(0, parameter.sortOrder.length - 3) : ''
          const page = {
            pageNo: parameter.pageNo,
            pageSize: parameter.pageSize,
            sortField: parameter.sortField,
            draw: order
          }
          return whole.getWholeCourseList(Object.assign(transferQuery, page))
        }
      }
    },
    computed: {
      ...mapState({
        userData: state => {
          if (state.user.userData.name) {
            return state.user.userData
          } else {
            return JSON.parse(localStorage.getItem('user'))
          }
        }
      })
    },
    filters: {},
    methods: {
      resetSearch() {
        this.queryParam = {}
        this.$refs.table.refresh(true)
      },
      goToCourseList(record) {
        if (this.$route.name === 'homeWholeCourse') {
          this.$router.push('/home/homeWholeCourseDetail')
        } else {
          this.$router.push('/home/wholeCourseDetail')
        }
        sessionStorage.setItem('wholeCourseId', record.id)
        sessionStorage.setItem('courseDate', record.startDate + '~' + record.finishDate)
      },
      goToPay(record) {
        // 调用接口判断课程体系是否支付过&&判断当前人的信息是否完善
        whole.checkPaidWholeCourse({
          wholeId: record.wholeId,
          wholeCourseId: record.id
        }).then(res => {
          // isPaying true:支付过 false:未支付过
          sessionStorage.setItem('isPaying', res.result)

          if (this.$route.name === 'homeWholeCourse') {
            this.$router.push('/home/homeWholeCoursePay')
          } else {
            this.$router.push('/home/wholeCoursePay')
          }
          sessionStorage.setItem('wholeCourseId', record.id)
          sessionStorage.setItem('courseDate', record.startDate + '~' + record.finishDate)
        })
      }
    },
    created() {
      // 如果不存在详情所需数据，则跳转到列表
      if (!sessionStorage.getItem('wholeId')) {
        this.$router.push('/home/whole')
        return
      }
      Promise.all([
        getListByCode({ dictCode: this.dictCode }).then(res => {
          this.options = { ...this.options, ...res.result.dictDefine }
        }),
        whole.selectWholeById({ id: sessionStorage.getItem('wholeId') }).then(res => {
          this.wholeName = res.result.name
          this.wholeRemarks = res.result.remarks
        })
      ])
    },
    destroyed() {
    }

  }
</script>
<style lang="less">
  .whole-course {

    .ant-btn-round {
      border-radius: 0.075rem;
    }

    .ant-form label {
      font-size: 0.135rem;
    }

    .ant-input {
      font-size: 0.135rem;
      height: 0.3rem;
    }

    .ant-btn-primary {
      width: 0.75rem;
      height: 0.3rem;
      background-color: rgba(23, 77, 244, 1);
      border-color: rgba(23, 77, 244, 1);
      color: rgba(255, 255, 255, 1);
      font-size: 0.135rem;
    }

    .reset-btn {
      width: 0.75rem;
      height: 0.3rem;
      margin-left: 0.195rem;
      background-color: rgba(0, 0, 0, 0);
      border-color: rgba(23, 77, 244, 1);
      color: rgba(23, 77, 244, 1);
      font-size: 0.135rem;
    }

    .whole-name {
      width: fit-content;
      font-size: 0.15rem;
      line-height: 0.2rem;
      margin-bottom: 0.1875rem;
      margin-top: 0.075rem;
    }

    .ant-alert-message {
      margin-right: 20px;
    }

    .ant-alert-description {
      white-space: pre-wrap;
    }
  }
</style>
